// SPDX-License-Identifier: AGPL-3.0-or-later
import {IS_DEV} from '@app/features/platform/types/Env';
import LocalPresence from '@app/features/presence/state/LocalPresence';
import {makeAutoObservable} from 'mobx';

const IDLE_DURATION_MS = 1000 * (IS_DEV ? 10 : 60 * 10);
const IDLE_CHECK_INTERVAL_MS = Math.floor(IDLE_DURATION_MS * 0.25);
class Idle {
	idle = false;
	private lastActivityTime = Date.now();
	private checkInterval: ReturnType<typeof setInterval> | null = null;
	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		this.startIdleCheck();
	}
	private startIdleCheck(): void {
		if (typeof setInterval !== 'function') return;
		this.checkInterval = setInterval(() => {
			this.updateIdleState();
		}, IDLE_CHECK_INTERVAL_MS);
	}
	destroy(): void {
		if (this.checkInterval !== null) {
			clearInterval(this.checkInterval);
			this.checkInterval = null;
		}
	}
	recordActivity(): void {
		this.lastActivityTime = Date.now();
		if (this.idle) {
			this.updateIdleState();
		}
	}
	markBackground(): void {
		this.lastActivityTime = 0;
		this.updateIdleState();
	}
	isIdle(): boolean {
		return this.idle;
	}
	getIdleSince(): number {
		return this.idle ? this.lastActivityTime : 0;
	}
	private updateIdleState(): void {
		const now = Date.now();
		const timeSinceActivity = now - this.lastActivityTime;
		const shouldBeIdle = timeSinceActivity >= IDLE_DURATION_MS;
		if (shouldBeIdle !== this.idle) {
			this.idle = shouldBeIdle;
			LocalPresence.updatePresence();
		}
	}
}
export default new Idle();
